import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StatisticsDto } from "../dtos/statistics.dto";
import { ApiService } from "./base/api.service";
import { CreatureLiteWebDto } from "../dtos/creature.lite.web.dto";
import { CreatureType } from "../enums/creature.type";
import { MarketplaceTradeListingDto } from "../dtos/marketplace-trade-listing.dto";

@Injectable({
    providedIn: 'root',
})
export class StatisticsService {

    private readonly baseUrl = 'statistics/';

    constructor(private apiService: ApiService) { }

    getStatistics(): Observable<StatisticsDto> {
        return this.apiService.get<StatisticsDto>(this.baseUrl);
    }

    getTopSalesCreatures(type: CreatureType): Observable<{creatures: CreatureLiteWebDto[], tradeListings: MarketplaceTradeListingDto[]}> {
        return this.apiService.get<{creatures: CreatureLiteWebDto[], tradeListings: MarketplaceTradeListingDto[]}>(this.baseUrl + type + '/top-sales');
    }

    getRecentListedCreatures(): Observable<CreatureLiteWebDto[]> {
        return this.apiService.get<CreatureLiteWebDto[]>(this.baseUrl + 'recent-listed');
    }
}